<template>
  <div class="sale-subscription-filter">
    <snow-select
      v-model="form.product_id"
      class="mb-4"
      label="Produto"
      id="product-select"
      placeholder="Todos os produtos"
      :options="productOptions"
    />

    <snow-checkboxes-dropdown
      v-model="form.status"
      :options="statuses"
      placeholder="Selecione o status"
      class="mb-4"
    />

    <div class="d-flex flex-lg-row flex-column gap-3">
      <snow-button
        size="lg"
        class="order-lg-1 w-100"
        text="Aplicar"
        @click="apply"
      />
      <snow-button
        size="lg"
        class="w-100"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      statuses: [
        { id: "enable", label: "Ativa" },
        { id: "disable", label: "Inativa" },
        { id: "fail", label: "Falha" },
        { id: "past_due", label: "Atrasada" }
      ],
      ...formFields(["product_id", "status"], {
        ...this.value
      })
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    productOptions() {
      return [{ id: "", name: "Todos os produtos" }, ...this.products];
    }
  },
  methods: {
    apply() {
      this.$emit("input", this.form);
      this.$emit("close");
    }
  }
};
</script>
